<header>
	<div class="header-top">
		<div class="container">
			<a [routerLink]="'route.csomag-hu.home' | translate" class="navbar-brand">
				<img src="/assets/img/logo-white.svg" width="95" height="32" alt="GLS" />
			</a>
			<button
				class="hamburger hamburger--squeeze"
				type="button"
				(click)="isNavbarCollapsed = !isNavbarCollapsed"
				aria-controls="navbarBottomContent"
				[attr.aria-expanded]="!isNavbarCollapsed"
				aria-label="Toggle navigation">
				<span class="hamburger-box">
					<span class="hamburger-inner"></span>
				</span>
			</button>
			<div class="panel">
				<div class="search-container">
					<div [class.open]="openSearchInput" class="form-floating">
						<ng-select
							class="search-input"
							[items]="(searchResults$ | async) || []"
							bindLabel="title"
							[formControl]="searchInput"
							[placeholder]="'parcel.search.btn-label' | translate"
							[minTermLength]="3"
							[loading]="searchResultLoading"
							typeToSearchText="Please enter 3 or more characters"
							[typeahead]="searchInput$"
							(change)="onChange($event)">
							>
							<ng-template ng-label-tmp let-item="item">
								<span [innerHTML]="item.title"></span>
							</ng-template>
							<ng-template ng-option-tmp let-item="item">
								<span [innerHTML]="item.title"></span>
							</ng-template>
						</ng-select>
					</div>
					<a nohref (click)="openSearchInput = !openSearchInput">
						<span [inlineSVG]="'/assets/img/icons/search.svg'" class="icon"></span>
					</a>
				</div>
				<div class="language-selector" ngbDropdown>
					<a nohref ngbDropdownToggle>
						<span [inlineSVG]="'/assets/img/icons/language.svg'" class="icon"></span>
						<span>
							<!-- Nyelv választás -->
							{{ 'header.top.language-select' | translate }}
						</span>
					</a>
					<div ngbDropdownMenu aria-labelledby="dropdown-language-select" class="dropdown-menu dropdown-menu-right">
						<button type="button" ngbDropdownItem (click)="selectLang('hu')">HU</button>
						<button type="button" ngbDropdownItem (click)="selectLang('en')">EN</button>
					</div>
				</div>
				<a [routerLink]="'route.csomag-hu.faq' | translate">
					{{ 'header.top.faq' | translate }}
				</a>
			</div>
		</div>
	</div>
	<div [ngbCollapse]="isNavbarCollapsed" class="header-bottom">
		<div class="container">
			<div class="customer-support" *ngIf="(customerSupport$ | async)?.[0] as customerSupport">
				<div>
					<p class="title">{{ 'header.customer-support.title' | translate }}</p>
					<p>{{ customerSupport.description }}</p>
				</div>
				<div>
					<p class="phone">
						<a [href]="'tel:' + customerSupport.phoneNumber">{{ customerSupport.phoneNumber }}</a>
						<span *ngIf="customerSupport.phoneNumberHelp">{{ customerSupport.phoneNumberHelp }}</span>
					</p>
					<p class="email">
						<a [href]="'mailto:' + customerSupport.emailAddress">{{ customerSupport.emailAddress }}</a>
					</p>
				</div>
			</div>
			<div class="panel">
				<div class="form-floating">
					<ng-select
						class="search-input"
						[items]="(searchResults$ | async) || []"
						bindLabel="title"
						[formControl]="searchInput"
						[placeholder]="'parcel.search.btn-label' | translate"
						[minTermLength]="3"
						[loading]="searchResultLoading"
						typeToSearchText="Please enter 3 or more characters"
						[typeahead]="searchInput$"
						(change)="onChange($event)">
						>
						<ng-template ng-label-tmp let-item="item">
							<span [innerHTML]="item.title"></span>
						</ng-template>
						<ng-template ng-option-tmp let-item="item">
							<span [innerHTML]="item.title"></span>
						</ng-template>
					</ng-select>
				</div>
				<div class="language-selector" ngbDropdown>
					<a nohref ngbDropdownToggle>
						<span [inlineSVG]="'/assets/img/icons/language.svg'" class="icon"></span>
						<span>
							<!-- Nyelv választás -->
							{{ 'header.top.language-select' | translate }}
						</span>
					</a>
					<div ngbDropdownMenu aria-labelledby="dropdown-language-select" class="dropdown-menu dropdown-menu-right">
						<button type="button" ngbDropdownItem (click)="selectLang('hu')">HU</button>
						<button type="button" ngbDropdownItem (click)="selectLang('en')">EN</button>
					</div>
				</div>
			</div>
			<nav>
				<a [routerLink]="'route.csomag-hu.send-parcel' | translate" routerLinkActive="active">
					{{ 'header.menu.send-parcel' | translate }}
				</a>
				<a [routerLink]="'route.csomag-hu.receive-parcel' | translate" routerLinkActive="active">
					{{ 'header.menu.receive-parcel' | translate }}
				</a>
				<a [routerLink]="'route.csomag-hu.service' | translate" routerLinkActive="active">
					{{ 'header.menu.service' | translate }}
				</a>
			</nav>
		</div>
	</div>
</header>
